export default __webpack_public_path__ + "static/media/10.620e2028.png";